import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { validateAmount } from 'pages/Wallets/components/FiatSend/form/fiatSendFormSchema'
import { createPaymentReferenceSchema } from 'utils/yupSchemas/createReferenceSchema'

export interface RefundFormPayload {
  reference: string
  password: string
  transferDestination?: string
  fee?: string
  maximumRefundAmount?: string
  amount: string
}

export type RefundFormPayloadKeys = keyof RefundFormPayload

export const refundSchema = (t: TFunction<'translation', undefined>) => {
  const reference = createPaymentReferenceSchema(t('reference'), t)
  const password = yup.string().trim().required()
  const transferDestination = yup.string().trim()
  const fee = yup.string().trim()
  const maximumRefundAmount = yup.string().trim()
  const amount = yup
    .string()
    .required()
    .test((value, ctx) => validateAmount({ value, ctx, t }))

  const formFields = {
    reference,
    password,
    transferDestination,
    fee,
    maximumRefundAmount,
    amount,
  }

  return yup.object<Partial<Record<keyof RefundFormPayload, yup.AnySchema>>>(formFields)
}
